// extracted by mini-css-extract-plugin
export default {"icon":"DeleteIcon_icon__JiOpM","wrapper":"DeleteIcon_wrapper__gniSZ"};